$ = jQuery;
$(document).ready(function()
{
  $(window).resize(function()
  {
    dynamic_window_resize();
  });
  
  navbar = $("nav.nav-bar");
  contentOffset = parseInt($("main.main-content").offset().top-$(window).scrollTop(),10);
  $(window).scroll(function()
  {
    contentOffset = parseInt($("main.main-content").offset().top-$(window).scrollTop(),10);
    if(contentOffset < 0)
    {
      //$(navbar).stop().animate({"opacity":"0.8"},200);
      if(!$(navbar).hasClass("minimised"))
      {
        $(navbar).find("#logo img").stop().animate({"top":"-200px","opacity":"0"},800);
        setTimeout(function()
		{
          $(navbar).addClass("minimised");
          $(".site-nav--mobile").stop().animate({"margin-top":"4px"},800);
          $(navbar).find(".site-nav").stop().animate({"height":"60px"},800);
          $(navbar).find("#logo .logoLabel").stop().animate({"margin-top":"-2px"},800);
          $(navbar).find(".social-icons").stop().animate({"margin-top":"20px"},800);
        },200);
      }
    }
    else
    {
      //$(navbar).stop().animate({"opacity":"1"},200);
      if($(navbar).hasClass("minimised"))
      {
        $(navbar).find(".site-nav").stop().animate({"height":"134px"},800);
        $(navbar).find("#logo .logoLabel").stop().animate({"margin-top":"75px"},800);
        $("#logo.mobile .logoLabel").stop().animate({"margin-top":"90px"},800);
        $(".site-nav--mobile").stop().animate({"margin-top":"76px"},800);
        $(navbar).find(".social-icons").stop().animate({"margin-top":"95px"},800);
        setTimeout(function()
		{
          $(navbar).removeClass("minimised");
          $(navbar).find("#logo img").stop().animate({"top":"0","opacity":"1"},800);
          $("#logo.mobile img").stop().animate({"top":"-82px","opacity":"1"},800);
        },200);
      }
    }
  });

  $("#mainLoader").css({"width":$(window).width()+"px","height":$(window).height()+"px"});
  $("#mainLoader .loader").css({"left":($(window).width()-75)/2+"px","top":($(window).height()-75)/2+"px"});
  setInterval(function(){
    if($("#mainLoader .loader").hasClass("visible"))
      $("#mainLoader .loader").fadeOut(800).removeClass("visible");
    else
      $("#mainLoader .loader").fadeIn(800).addClass("visible");
  },800);
  
});

document.onreadystatechange = function()
{
  if(document.readyState=="complete")
  {
    dynamic_window_resize();
    $("#mainLoader").fadeOut(800);
    $("#PageContainer").delay(1000).animate({"opacity":"1"},500);
    if($("body").is("#lookbook"))
    {
      var video = document.getElementById("lookbook-video");
      video.play();
      $("#lookbook-video").addClass("playing");
      $("#lookbook-video").on("click",function()
      {
        if($("#lookbook-video").hasClass("playing"))
        {
          video.pause();
          $("#lookbook-video").removeClass("playing");
        }
        else
        {
          video.play();
          $("#lookbook-video").addClass("playing");
        }
      });
    }
    //showNotification();
  }
};


function dynamic_window_resize()
{
  $(".product_listing").each(function()
  {
    $(this).find(".image img").first().css({"left":(($(this).width()-$(this).find("img").width())/2)+"px"});
  });
  
  $("#logo.mobile img").css({"left":($("#logo.mobile").width()-$("#logo.mobile img").width())/2+"px"});
  
  $("#about-image img").css({"top":($("#about-image").height()-$("#about-image img").height())/2+"px"});
  $("#about-wide-image img").css({"top":($("#about-wide-image").height()-$("#about-wide-image img").height())/2+"px"});
  
  $("#bespoke-top img").css({"top":($("#bespoke-top").height()-$("#bespoke-top img").height())/2+"px"});
  
  $(".blog-post-listing").each(function()
  {
    $(this).find(".blog-image img").css({"top":"-"+($(this).find(".blog-image img").height()-$(this).height())/2+"px"});
  });
}
function toggle_product_description(ele)
{
  var parent = $(ele).parent();
  if($(parent).hasClass("un-toggled"))
  {
    $(parent).removeClass("un-toggled");
    $(parent).find("img").first().stop().animate({
      "opacity":"0.2"
    },400);
    $(parent).find(".overlay").fadeIn(400);
    $(parent).addClass("toggled");
  }
  else if($(parent).hasClass("toggled"))
  {
    $(parent).removeClass("toggled");
    $(parent).find("img").first().stop().animate({
      "opacity":"1"
    },400);
    $(parent).find(".overlay").fadeOut(400);
    $(parent).addClass("un-toggled");
  }
}
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}
function showNotification()
{
  var cookies = document.cookie;
  var cookies = cookies.split(";");
  for(xx=0;xx<cookies.length;xx++)
  {
    var flag = false;
    var cookie = cookies[xx];
    var cookie = cookie.split("=");
    var cookieName = cookie[0];
    var cookieVal = cookie[1];
    if(getCookie("notiClosed"))
    {
      var flag = true;
    }
  }
  if(flag==false)
  {
    $("header #notification").slideDown();
    $("body").css({"padding-top":$("header").height()+40+"px"});
  }
}
function hideNotification()
{
  $("header #notification").slideUp();
  $("body").animate({"padding-top":$("header").height()-40+"px"},"600");
  var d = new Date();
  d.setTime(d.getTime() + (30*24*60*60*1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = "notiClosed=true; "+expires;
}